import React from "react";
import { Card, Typography, Row, Col, Statistic, Tabs } from "antd";

import { UpdateEndpointCors } from "../modal/UpdateEndpointCors";
import { Endpoint } from "../endpoint/Endpoint";

const { TabPane } = Tabs;

interface Props {
  project: { id: string; allowOrigins: string };
}

export function Endpoints({ project }: Props) {
  const tabItem = [
    {
      name: "Cronos Mainnet",
      chain: "cronos",
      network: "mainnet",
    },
    {
      name: "Cronos Testnet",
      chain: "cronos",
      network: "testnet",
    },
  ];

  return (
    <>
      {project ? (
        <Card size="small" style={{ marginBottom: "24px" }}>
          <Row gutter={16}>
            <Col flex={1}>
              <Statistic
                className="ant-statistic-small"
                title="Project ID"
                value={project.id}
                formatter={(value) => {
                  return <Typography.Text copyable>{value}</Typography.Text>;
                }}
              />
            </Col>
            <Col flex={1} style={{ alignSelf: "center", textAlign: "end" }}>
              <UpdateEndpointCors project={project} />
            </Col>
          </Row>
        </Card>
      ) : null}

      <Tabs>
        {tabItem.map((item, index) => (
          <TabPane tab={item.name} key={index}>
            <Endpoint project={project} chain={item.chain} network={item.network} />
          </TabPane>
        ))}
      </Tabs>
    </>
  );
}
